import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loggedOut } from "./authSlice";
import { api } from "../../api/apiSlice";
import { paths } from "../../routes/paths";

export const useLogout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return () => {
    dispatch(loggedOut());
    dispatch(api.util.resetApiState());
    navigate(paths.signin, { replace: true });
  };
};
